import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { IAgentDetail, IRadiusClient } from '@app/models';
import { AgentViewType } from '@app/pages/authManager/dialogs/addAgent.dialog';

interface IProps {
    editAgentCallback: Function;
    agent: IAgentDetail;
    radiusConfig: any;
    radiusClients: IRadiusClient[];
}

const ReadRadiusConfig: React.SFC<IProps> = ({ editAgentCallback, agent, radiusConfig, radiusClients }) => {
    const { translation } = useTypedTranslation();

    return (
        <div className='detailPage__section'>
            <div className='detailPage__section-head'>
                {translation('RADIUS_CONFIGURATION_TAB')}
            </div>
            <div className='detailPage__section-content'>
                <ul className='detailPage__list'>
                    <li>
                        <a id='editAgentLink' className='detailPage__list--primary-label' onClick={() => editAgentCallback(AgentViewType.editAgentExtendedView)}>{translation('EDIT')}</a>
                    </li>
                    <li>
                        <span className='detailPage__list--primary-label'>{translation('APP_RADIUS_PORT_LABEL')}</span>
                        <span className='detailPage__list--secondary-label'>{radiusConfig?.RadiusPort}</span>
                    </li>

                    <span className='configpanel-left--radius-configuration-client'><b>{translation('RADIUS_CLIENTS')}</b></span>
                    {radiusClients.length > 0 ?
                        <>
                            <div className='configpanel-left--radius-configuration-row'>
                                <div>{translation('RADIUS_CLIENT_NAME_LABEL')}</div>
                                <div>{translation('RADIUS_CLIENT_IP_LABEL')}</div>
                                <div>{translation('RADIUS_CLIENT_POLICY_LABEL')}</div>
                                <div />
                                <div />
                            </div>
                            <div className='configpanel-left--radius-configuration-column'>{
                                radiusClients.map((client: IRadiusClient, index: number) => (
                                    <div key={index} className='configpanel-left--radius-configuration-rowcontainer'>
                                        <div>{client.name}</div>
                                        <div>{client.ip}</div>
                                        <div>{client.policy.label}</div>
                                        <div />
                                        <div />
                                    </div>
                                ))}
                            </div>
                        </>
                        :
                        <div className='configpanel-left--radius-configuration-row'>
                            <span>{translation('EMPTY_RADIUS_CLIENT_LIST')}</span>
                        </div>
                    }
                </ul>
            </div>
        </div>
    );
};

export default ReadRadiusConfig;